module.exports = __webpack_public_path__ + "img/rosemount-702-wireless-discrete-transmitter-1-facing-left.9a62d03d.png";